import { Card } from '@mui/material';

export default function AppCard({ children, sx, ...props }) {
    return (
        <Card sx={{ p: { xs: 2, md: 3 }, ...sx }} {...props}>
            {children}
        </Card>
    );
}
